import { get } from '@ember/object';
import Component from '@glimmer/component';

import { t } from 'ember-intl';
import PowerSelect from 'ember-power-select/components/power-select';
import { not } from 'ember-truth-helpers';

export default class UiFormFieldSelectValueComponent extends Component {
  // Getter and setter
  get labelProperty() {
    return this.args.labelProperty ?? 'label';
  }

  get searchField() {
    return this.args.searchField ?? 'label';
  }

  get selected() {
    if (this.args.selected) {
      return this.args.selected;
    }

    if (this.args.value === undefined || this.args.value === null) {
      return undefined;
    }

    return (
      this.args.options?.find(
        (option) => option[this.selectPath] === this.args.value,
      ) ?? {
        [this.labelProperty]: `${this.args.value} (Invalid!)`,
      }
    );
  }

  get selectPath() {
    return this.args.selectPath ?? 'value';
  }

  // Functions
  onChange = (option) => {
    if (this.args.onChange) {
      return this.args.onChange(option);
    }

    let newProperty = option ? option[this.selectPath] : null;

    if (this.args.model.set) {
      this.args.model.set(this.args.property, newProperty);
    } else {
      this.args.model[this.args.property] = newProperty;
    }

    this.args.onShowValidations();
  };

  // Template
  <template>
    <PowerSelect
      @allowClear={{not @isRequired}}
      @disabled={{@isDisabled}}
      @loadingMessage={{t 'ui.form.field.select.loading_message'}}
      @onChange={{this.onChange}}
      @options={{@options}}
      @placeholder={{@placeholder}}
      @renderInPlace={{@renderInPlace}}
      @search={{@search}}
      @searchEnabled={{@isSearchEnabled}}
      @searchField={{this.searchField}}
      @searchMessage={{t 'ui.form.field.select.search_message'}}
      @searchPlaceholder={{t 'ui.form.field.select.search_placeholder'}}
      @selected={{this.selected}}
      as |option|
    >
      {{#if (has-block)}}
        {{yield option this.labelProperty}}
      {{else}}
        {{get option this.labelProperty}}
      {{/if}}
    </PowerSelect>
  </template>
}
